<div class="billingSectionSwitch__cont">
  <app-ds-tab
    [options]="options"
    [type]="tabType"
    [size]="tabSize"
    [isDisabled]="disbleSwitch"
    [defaultOption]="defaultOption"
    (selectTab)="onClickSwitch($event)">
  </app-ds-tab>
</div>
